
export const onboarding = {
  title: "Creator oldalad létrehozása",
  navigation: {
    back: "Vissza",
    next: "Tovább",
    finish: "Befejezés"
  },
  toast: {
    name_required: "Név kötelező",
    name_required_desc: "Kérjük, add meg a creator nevedet a folytatás előtt.",
    thank_you: "Köszönjük!",
    thank_you_desc: "Az onboarding információkat sikeresen elküldtük.",
    saved: "Profil mentve",
    saved_desc: "A creator profilod sikeresen létrehozva.",
    error: "Hiba",
    error_desc: "Hiba történt a profilod mentése közben. Kérjük, próbáld újra."
  },
  steps: {
    basic_info: {
      title: "Alapvető információk",
      description: "Add meg a legfontosabb infókat a profilod felépítéséhez.",
      tip_title: "Miért fontos ez?",
      tip_description: "Egy jó profil kép és leírás növeli a bizalmat a vásárlóidban. A kategóriák segítenek, hogy megtaláljon a neked megfelelő célközönséged.",
      personal_data: "Személyes adatok",
      creator_name: "Creator neved",
      creator_name_placeholder: "Add meg a creator nevedet",
      main_keywords: "Fő hívószavak (minimum 2 db)",
      keywords_help: "Válassz szavakat, amik legjobban jellemeznek téged",
      keywords_selected: "hívószó kiválasztva",
      keywords_minimum: "(minimum 2 szükséges)",
      keywords_placeholder: "Válaszd ki a rád leginkább jellemző szavakat...",
      keywords_list: [
        "fenntartható", "exkluzív", "technológiai", "kreatív", "innovatív", "autentikus",
        "inspiráló", "motiváló", "oktatási", "szórakoztató", "praktikus", "elegáns",
        "modern", "hagyományos", "szakértői", "barátságos", "energikus", "nyugodt",
        "színes", "minimalista", "luxus", "megfizethető", "egyedi", "közösségi",
        "személyes", "professzionális", "családias", "fiatalos", "tapasztalt", "divatos"
      ],
      profile_picture: "Profilkép",
      upload_image: "Kép feltöltése",
      categories_placeholder: "Válaszd ki a területeidet a lenti kategóriákból...",
      category_label: "Területeid",
      categories_selected: "kiválasztva",
      selected_categories: "Kiválasztott területeid",
      categories_summary: "Nagyszerű! {count} területet választottál ki. Nyugodtan válassz többet is, ha releváns a tartalmaidra!",
      categories: {
        chef: "Séf / gasztro szakértő",
        fitness: "Fitness edző",
        travel_blogger: "Utazási blogger",
        photographer: "Fotós",
        beauty_expert: "Szépségipari szakértő",
        fashion_stylist: "Divattervező / stylist",
        gamer: "Gamer / streamer",
        tech_expert: "Tech szakértő",
        teacher: "Tanár / oktató",
        musician: "Zenész / előadó",
        artist: "Művész / grafikus",
        comedian: "Humorista / előadó",
        lifestyle: "Életmód tanácsadó",
        business: "Üzleti tanácsadó",
        health: "Egészségügyi szakértő",
        podcaster: "Podcaster",
        influencer: "Influenszer",
        writer: "Író / újságíró",
        actor: "Színész",
        other: "Egyéb"
      }
    },
    social_media: {
      title: "Közösségi média linkek",
      description: "Add meg közösségi média elérhetőségeidet, hogy vásárlóid könnyedén megtalálhassanak.",
      tip_title: "Miért fontos ez?",
      tip_description: "A közösségi média linkek segítenek a rajongóidnak, hogy követhessenek téged minden platformon. Ezek mind opcionálisak - add hozzá azokat, amiket használsz.",
      no_platforms: "Még nincs csatlakoztatott platform",
      platforms_connected: "platform csatlakoztatva",
      connected_platforms: "Csatlakoztatott platformok",
      connect_platform: "kiválasztva",
      username_or_profile: "Felhasználónév vagy profil",
      website_url: "Weboldal URL",
      save: "Mentés",
      delete: "Törlés",
      youtube_placeholder: "https://youtube.com/c/csatornanev",
      username_placeholder: "@felhasznalonev",
      platforms: {
        instagram: {
          name: "Instagram",
          placeholder: "@felhasznalonev"
        },
        youtube: {
          name: "YouTube",
          placeholder: "Csatorna neve vagy URL"
        },
        tiktok: {
          name: "TikTok",
          placeholder: "@felhasznalonev"
        },
        twitter: {
          name: "Twitter/X",
          placeholder: "@felhasznalonev"
        },
        facebook: {
          name: "Facebook",
          placeholder: "Oldal neve"
        },
        linkedin: {
          name: "LinkedIn",
          placeholder: "Profil neve"
        }
      }
    },
    audience: {
      title: "Célközönség",
      description: "Segíts megérteni, kinek szól a tartalmod.",
      tip_title: "Miért fontos ez?",
      tip_description: "A célközönséged ismerete segít személyre szabni a tartalmadat és a kommunikációdat. Több korosztályt és stílust is választhatsz.",
      primary_age_group: "Elsődleges korosztály",
      selected: "kiválasztva",
      communication_style: "Hogyan szólítanád meg a közönségedet?",
      summary_title: "A te célközönséged",
      age_groups: "Korosztályok:",
      age_group: "Korosztály",
      communication_styles: "Kommunikációs stílus:",
      address_style_question: "Hogyan szeretnél kommunikálni a követőiddel?",
      age_options: {
        "all-ages": {
          label: "Minden korosztály",
          description: "Minden korú ember számára releváns tartalom"
        },
        "13-17": {
          label: "13-17 év",
          description: "Középiskolások, fiatal tinédzserek"
        },
        "18-24": {
          label: "18-24 év",
          description: "Egyetemisták, kezdő karrierépítők"
        },
        "25-34": {
          label: "25-34 év",
          description: "Fiatal felnőttek, karrieristák"
        },
        "35-44": {
          label: "35-44 év",
          description: "Családalapítók, tapasztalt szakemberek"
        },
        "45+": {
          label: "45+ év",
          description: "Tapasztalt felnőttek, mentorálók"
        }
      },
      communication_options: {
        casual: {
          label: "Közvetlen és barátságos",
          description: "Lazán, mint egy jó baráttal beszélnél",
          example: "\"Szia! Ma megmutatom neked...\""
        },
        professional: {
          label: "Professzionális és formális",
          description: "Szakszerűen, tiszteletteljes hangnemben",
          example: "\"Szeretném bemutatni Önöknek...\""
        },
        motivational: {
          label: "Motiváló és inspiráló",
          description: "Lelkesítően, pozitív energiával",
          example: "\"Te is képes vagy rá! Kezdjük el...\""
        },
        humorous: {
          label: "Humoros és szórakoztató",
          description: "Vidáman, sokat nevetve",
          example: "\"Készülj fel, mert ez brutális lesz! 😄\""
        }
      },
      address_styles: {
        casual: "Közvetlen és barátságos",
        professional: "Professzionális és formális",
        motivational: "Motiváló és inspiráló",
        humorous: "Humoros és szórakoztató"
      },
      examples: {
        "all-ages": ["Minden korosztály", "Általános tartalom", "Széles közönség"],
        "13-17": ["TikTok tartalmak", "Gaming", "Zene"],
        "18-24": ["Lifestyle", "Tanulási tippek", "Karrier tanácsok"],
        "25-34": ["Szakmai fejlődés", "Wellness", "Kapcsolatok"],
        "35-44": ["Szülői tanácsok", "Otthon", "Egészség"],
        "45+": ["Bölcsességek", "Hobbik", "Nyugdíj előkészítés"]
      },
      example_label: "Példa:"
    },
    services: {
      title: "Szolgáltatásaid",
      description: "Válaszd ki, mely szolgáltatásokat szeretnéd kínálni a közönségednek.",
      tip_title: "Miért fontos ez?",
      tip_description: "Kezdd 2-3 szolgáltatással, amit biztosan tudsz vállalni. Később bármikor bővítheted a kínálatodat. A vegyes árkategóriák segítenek elérni különböző vásárlókat.",
      ai_recommendation: "AI asszisztensünk ajánlása az eddig megadott infók alapján",
      ai_description: "A kiválasztott területeid alapján ezeket a szolgáltatásokat ajánljuk:",
      select_services: "Válassz ki néhány szolgáltatást",
      services_selected: "szolgáltatás kiválasztva",
      selected_services: "Kiválasztott szolgáltatásaid",
      potential_revenue: "Potenciális bevétel",
      examples: "Példák:",
      services: "Szolgáltatások",
      help_text: "Válaszd ki azokat a szolgáltatásokat, amelyeket szeretnél kínálni.",
      personalVideos: "Személyes videóüzenetek",
      personalVideosDesc: "Személyre szabott videóüzenetek rajongóknak",
      privateMessages: "Privát üzenetek",
      privateMessagesDesc: "Egyéni tanácsadás írásban",
      digitalContent: "Digitális tartalmak",
      digitalContentDesc: "E-könyvek, útmutatók",
      oneOnOneConsultation: "Egyéni konzultáció",
      oneOnOneConsultationDesc: "Személyes videóhívás",
      groupConsultation: "Csoportos események",
      groupConsultationDesc: "Csoportos események",
      subscriptionContent: "Előfizetéses tartalmak",
      subscriptionContentDesc: "Rendszeres exkluzív tartalom",
      selected: "Kiválasztott szolgáltatások",
      selectedHelp: "Ezeket a szolgáltatásokat fogod tudni kínálni a rajongóidnak.",
      service_types: {
        personalVideos: {
          title: "Személyes videóüzenetek",
          shortDesc: "Egyedi videók rajongóknak",
          description: "Személyre szabott videóüzeneteket küldhetsz követőidnek különleges alkalmakra",
          price: "5.000 - 25.000 Ft",
          time: "5-15 perc",
          examples: ["Születésnapi köszöntő", "Motivációs üzenet", "Tanácsadás"]
        },
        privateMessages: {
          title: "Privát üzenetek",
          shortDesc: "Egyéni tanácsadás írásban",
          description: "Személyes szöveges üzenetek és tanácsadás követőidnek",
          price: "1.000 - 5.000 Ft",
          time: "Azonnali",
          examples: ["Gyors tanács", "Kérdés megválaszolása", "Motiváció"]
        },
        digitalContent: {
          title: "Digitális tartalmak",
          shortDesc: "E-könyvek, útmutatók",
          description: "E-könyvek, útmutatók, sablonok és egyéb letölthető tartalmak",
          price: "2.000 - 15.000 Ft",
          time: "Azonnali letöltés",
          examples: ["Template csomagok", "Edzéstervek", "Preset csomagok"]
        },
        oneOnOneConsultation: {
          title: "Egyéni konzultáció",
          shortDesc: "Személyes videóhívás",
          description: "Személyes videóhívások mélyebb tanácsadáshoz és coaching-hoz",
          price: "10.000 - 50.000 Ft",
          time: "30-60 perc",
          examples: ["Coaching session", "Szakmai tanácsadás", "Mentorálás"]
        },
        groupConsultation: {
          title: "Csoportos események",
          shortDesc: "Csoportos események",
          description: "Online és offline csoportos workshopok",
          price: "3.000 - 15.000 Ft/fő",
          time: "60-90 perc",
          examples: ["Workshop", "Q&A session", "Közösségi esemény"]
        },
        subscriptionContent: {
          title: "Előfizetéses tartalmak",
          shortDesc: "Rendszeres exkluzív tartalom",
          description: "Havi vagy heti exkluzív tartalmak előfizetés alapon",
          price: "2.000 - 10.000 Ft/hó",
          time: "Folyamatos",
          examples: ["Heti tippek", "Exkluzív videók", "Korai hozzáférés"]
        }
      }
    },
    design: {
      title: "Megjelenés, arculat",
      description: "Válaszd ki, milyen megjelenési stílust szeretnél az oldaladon.",
      tip_title: "Profi tipp",
      tip_description: "A jó design növeli a bizalmat és segít kitűnni a versenytársaid közül. Válassz olyan stílust, ami tükrözi a személyiségedet és vonzza a célközönségedet.",
      choose_style: "Válassz design stílust",
      selected: "Kiválasztva",
      color_palette: "Színpaletta választás",
      font_selection: "Betűtípus választás",
      inspiration_images: "Inspirációs képek (opcionális)",
      select_images: "Válassz képeket, amelyek inspirálnak",
      upload_own: "Saját kép feltöltése",
      design_inspiration_note: "💡 Ezek csak inspirációs példák - az oldalad teljesen egyedi dizájnnal készül el!",
      design_styles: {
        minimal: {
          title: "Minimalista",
          description: "Tiszta, egyszerű design kevés elemmel"
        },
        modern: {
          title: "Modern",
          description: "Kortárs design élénk színekkel"
        },
        vibrant: {
          title: "Élénk",
          description: "Feltűnő színek és gradientek"
        },
        elegant: {
          title: "Elegáns",
          description: "Kifinomult, prémium megjelenés"
        },
        natural: {
          title: "Természetes",
          description: "Természetes színek és formák"
        },
        playful: {
          title: "Játékos",
          description: "Vidám, kreatív megjelenés"
        }
      },
      font_categories: {
        sans_serif: "Sans-serif",
        serif: "Serif",
        display: "Display"
      },
      color_palettes: {
        "natural-green": "Természetes Zöldek",
        "scandinavian-light": "Skandináv Világos",
        "modern-tech-blue": "Modern Techkék",
        "pastel-cheerful": "Pasztell Vidám",
        "dark-elegance": "Sötét Elegancia",
        "bohemian-purple": "Bohém Lila",
        "warm-sunset": "Meleg Naplemente",
        "minimal-beige": "Minimal Bézs",
        "nordic-cool": "Északi Hűvös",
        "refreshing-spring": "Frissítő Tavasz",
        "mature-autumn": "Érett Ősz",
        "creative-momentum": "Kreatív Lendület",
        "dark-theme": "Sötét Téma",
        "delicate-pastel": "Finom Pasztell",
        "luxury-gold": "Luxus Arany",
        "retro": "Retro",
        "scandinavian-stone": "Skandináv Kő",
        "romantic": "Romantikus",
        "coastal": "Tengerparti",
        "dark-green": "Sötét Zöld"
      },
      font_options: {
        inter: { name: "Inter", description: "Modern és tiszta", sample: "Az élet szép, éljük át!" },
        poppins: { name: "Poppins", description: "Barátságos és könnyen olvasható", sample: "Kreativitás minden napra" },
        montserrat: { name: "Montserrat", description: "Elegáns és professzionális", sample: "Sikeres vállalkozás titkai" },
        playfair: { name: "Playfair Display", description: "Klasszikus és kifinomult", sample: "Művészet és szépség" },
        merriweather: { name: "Merriweather", description: "Olvasható és tradicionális", sample: "Történetek és élmények" },
        oswald: { name: "Oswald", description: "Erős és figyelemfelkeltő", sample: "HATÁROZOTT ÜZENET" },
        manrope: { name: "Manrope", description: "Harmonikus és modern", sample: "Egyensúly és harmónia" },
        bangers: { name: "Bangers", description: "Játékos és energikus", sample: "FUN & CREATIVE!" }
      },
      design_elements: {
        minimal: ["egyszerű vonal", "üres tér"],
        modern: ["neon akcent", "geometrikus formák"],
        vibrant: ["színes foltok", "kreatív káosz"],
        elegant: ["arany díszítés", "szimmetria"],
        natural: ["organikus forma", "természetes textúra"],
        playful: ["vidám ikonok", "buborék formák"]
      },
      style_options: [
        "Minimalista fehér", "Modern gradient", "Organikus, természetes", "Prémium, sötét elegancia",
        "Játékos, illusztrált", "Retro/vintage", "Művészi, kreatív", "Monokróm (fekete-fehér)", 
        "Futurisztikus", "Pastell, soft", "Urban / Street", "Fotóalapú, magazin"
      ],
      upload_logo: "Saját logó feltöltése (opcionális)",
      upload_logo_description: "Töltsd fel a saját logódat, hogy személyre szabhasd az oldaladat.",
      upload_logo_button: "Logó feltöltése",
      upload_logo_formats: "PNG, JPG, SVG formátumban",
      font_selection_title: "Betűtípus választás",
      font_selection_description: "A betűtípus nagy hatással van az oldal hangulatára és olvashatóságára.",
      inspiration_gallery: "Inspirációs galéria",
      inspiration_optional: "(opcionális)",
      inspiration_description: "Válassz mood képeket, amelyek tetsznek neked vagy tükrözik a stílusodat. Ezek segítenek megérteni a vizuális preferenciáidat és hangulatodat.",
      upload_images: "Saját képek feltöltése",
      upload_images_description: "Kattints vagy húzd ide a képeket",
      images_selected: "kép kiválasztva",
      preview_title: "Az oldal előnézete",
      preview_design_style: "Design stílus:",
      preview_color_palette: "Színpaletta:",
      preview_font: "Betűtípus:",
      preview_inspiration: "Inspiráció:",
      preview_images: "kép",
      not_selected: "Nincs kiválasztva"
    }
  },
  ai_assistant: {
    title: "Személyre szabd az AI asszisztensedet",
    description: "Add meg az AI asszisztensed nevét és válassz neki egy avatart, hogy egyedi legyen az oldaladon.",
    fields: {
      name: {
        label: "AI asszisztens neve",
        placeholder: "pl. Anna, Péter, Zoli...",
        description: "Ez a név fog megjelenni, amikor az AI válaszol a látogatóidnak"
      },
      avatar: {
        label: "Avatar kiválasztása",
        description: "Válassz egy avatart, ami reprezentálja az AI asszisztensedet",
        select_placeholder: "Válassz AI assziszens személyiséget...",
        pick_your_vibe: "Válaszd ki a vibe-od!",
        selected_text: "Tökéletes választás! Így fog kinézni az AI asszisztensed 💫"
      }
    },
    avatars: {
      fairy_sparkle: "Csillogó Tündér",
      dragon_buddy: "Sárkány Barát",
      unicorn_magic: "Varázslatos Unikornis",
      phoenix_flame: "Lángos Főnix",
      griffin_golden: "Arany Griff",
      pegasus_cloud: "Felhős Pegazus",
      owl_wise: "Bölcs Bagoly",
      fox_magic: "Varázslatos Róka",
      cat_fluffy: "Puha Cica",
      rabbit_flower: "Virágos Nyuszi",
      bear_honey: "Mézes Medve",
      dolphin_splash: "Locsogó Delfin"
    }
  }
};
